import React from "react";
import { NumberInput } from "react-admin";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import RoomInput from "server/components/Fields/RoomInput";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import sessionExamsHelper from "components/AcademicYears/Exams/helper";

const EditForm = () => {
  const fromTime = useWatch({ name: "fromTime" });
  const toTime = useWatch({ name: "toTime" });

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <RoomInput />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <NumberInput
            source="studentsCapacity"
            label="Капацитет"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomTimeOnlyInput
            source="fromTime"
            label="Начало"
            required={true}
            validate={() =>
              sessionExamsHelper.validateTimeSlots({
                startTime: fromTime,
                endTime: toTime,
              })
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomTimeOnlyInput
            source="toTime"
            label="Край"
            required={true}
            validate={() =>
              sessionExamsHelper.validateTimeSlots({
                startTime: fromTime,
                endTime: toTime,
              })
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default EditForm;
